
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Breadcrumb from '../../components/feature/Breadcrumb';
import { usePageSEO } from '../../hooks/usePageSEO';
import { createBreadcrumbStructuredData, createArticleStructuredData } from '../../utils/structuredData';

export default function FxTradePage() {
  usePageSEO({
    title: 'DMM FX取引ガイド｜評判・キャンペーン・サポート情報',
    description: 'DMM FXの評判・口コミ、キャンペーン情報、サポート体制など、取引に関する情報をまとめています。',
    keywords: 'DMM FX,評判,口コミ,キャンペーン,サポート,デメリット',
    structuredData: [
      createBreadcrumbStructuredData([
        { name: 'ホーム', url: '/' },
        { name: 'DMM FX取引ガイド', url: '/fx-trade' },
      ]),
      createArticleStructuredData({
        headline: 'DMM FX取引ガイド',
        description: 'DMM FXの評判・口コミ、キャンペーン情報、サポート体制など。',
        author: 'DMM FX情報局',
        datePublished: '2024-01-15',
        dateModified: new Date().toISOString().split('T')[0],
        image: 'https://public.readdy.ai/ai/img_res/5825c79566126c85f9a4f6758de88fed.jpg',
        url: '/fx-trade',
      }),
    ],
  });

  const articles = [
    {
      icon: 'ri-star-line',
      title: '評判・口コミ',
      description: '実際の利用者1,247件の口コミを徹底分析。良い評判・悪い評判を正直に紹介。',
      url: '/reviews',
    },
    {
      icon: 'ri-gift-line',
      title: 'キャンペーン情報',
      description: '最大50万円キャッシュバックの詳細と受け取り方法を解説。',
      url: '/campaign',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'サポート情報',
      description: '24時間サポート体制、問い合わせ方法を詳しく解説。',
      url: '/support',
    },
    {
      icon: 'ri-error-warning-line',
      title: 'デメリット・注意点',
      description: 'DMM FXのデメリットと注意点を正直に解説。',
      url: '/disadvantages',
    },
    {
      icon: 'ri-scales-line',
      title: '他社との比較',
      description: 'DMM FXと他社FX業者を徹底比較。',
      url: '/comparison',
    },
    {
      icon: 'ri-smartphone-line',
      title: 'アプリの使い方',
      description: 'DMM FXスマホアプリの操作方法を画像付きで解説。',
      url: '/app-guide',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-24 pb-16">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <Breadcrumb items={[
            { name: 'ホーム', url: '/' },
            { name: 'DMM FX取引ガイド', url: '/fx-trade' },
          ]} />

          <div className="mb-10">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">DMM FX取引ガイド</h1>
            <p className="text-gray-600 leading-relaxed">
              DMM FXの評判・口コミ、キャンペーン情報、サポート体制など、取引に関する情報をまとめています。
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {articles.map((article, index) => (
              <Link
                key={index}
                to={article.url}
                className="group bg-white rounded-xl p-6 border border-gray-200 hover:shadow-lg hover:border-emerald-300 transition-all cursor-pointer"
              >
                <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-green-600 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                  <i className={`${article.icon} text-white text-xl`}></i>
                </div>
                <h2 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-emerald-600 transition-colors">
                  {article.title}
                </h2>
                <p className="text-sm text-gray-600 leading-relaxed mb-4">{article.description}</p>
                <div className="flex items-center text-emerald-600 text-sm font-semibold">
                  <span>詳しく見る</span>
                  <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform"></i>
                </div>
              </Link>
            ))}
          </div>

          {/* CTA */}
          <div className="mt-12 text-center bg-gradient-to-br from-emerald-50 to-green-50 rounded-2xl p-8">
            <p className="text-gray-700 mb-4">まずは無料で口座開設してみましょう</p>
            <a 
              href="https://px.a8.net/svt/ejp?a8mat=4AX8OA+BW2OQA+1WP2+6JC82" 
              rel="nofollow"
              className="inline-block bg-gradient-to-b from-orange-500 to-orange-600 text-white px-8 py-4 rounded-lg text-lg font-bold hover:scale-105 transition-all whitespace-nowrap cursor-pointer shadow-lg"
            >
              無料でDMM FX口座を開設する
            </a>
            <img border="0" width="1" height="1" src="https://www13.a8.net/0.gif?a8mat=4AX8OA+BW2OQA+1WP2+6JC82" alt="" style={{ display: 'none' }} />
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
